import { Component, OnInit } from '@angular/core';
import { Base } from '../base';
import { DataService } from '../services/data.service';

@Component({
  selector: 'app-history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.scss']
})
export class HistoryComponent extends Base implements OnInit {
  history: any = [];
  immagine1Url: string;
  immagine2Url: string;
  immagine3Url: string;

  constructor(private dataService: DataService) {
    super();
  }

  ngOnInit() {
    this.dataService.getHistory().subscribe(response => {
      this.history = response.Storia;
      this.immagine1Url = this.apiUrl + this.history.immagine1.url;
      this.immagine2Url = this.apiUrl + this.history.immagine2.url;
      this.immagine3Url = this.apiUrl + this.history.immagine3.url;
    });
  }
}
